<template>
  <div>
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
      integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ"
      crossorigin="anonymous"
    >

    <error-display />
    <form-wizard
      ref="wizard"
      :start-index="currentStep"
      @on-change="tabChange"
      shape="square"
      color="#3a5878">
      <span slot="title"
    />

      <tab-content
        v-for="(item, key) in steps"
        :key="key"
        :before-change="item.name === 'danovePriznanie' ? danovnikSwitch : next"
        :title="item.title"
        :icon="item.icon"
      />

      <hr>
      <transition
        name="fade"
        mode="out-in">
        <router-view name="a" />
      </transition>
      <hr>

      <div style="margin-top: 1.5em">
        <div style="float: left">
          <b-button
            v-if="currentStep !== 0"
            class="backBut"
            @click="backClicked"
          >
            <span style="float: right">{{ $t('message.butBack') }}</span>
            <i
              style="float: left; padding: 3px 10px 3px 3px"
              class="fas fa-arrow-left"
            />
          </b-button>
        </div>

        <div style="float: right">
          <b-button
            v-if="currentStep !== 4"
            @click="nextClicked"
            class="nextBut"
          >
            <span style="float:left">{{ $t('message.butNext') }}</span>
            <i
              style="float: right; padding: 3px 3px 3px 10px"
              class="fas fa-arrow-right"
            />
          </b-button>
        </div>
      </div>

    </form-wizard>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import './assets/jedno4.css'
import ErrorDisplay from './components/ErrorDisplay.vue'

export default {
  components: {
    ErrorDisplay
  },

  data() {
    return {
      steps: [
        {
          icon: 'fas fa-info',
          name: 'start',
          title: this.$t('message.wizPage1'),
          completed: false
        },
        {
          icon: 'fas fa-users',
          name: 'danovePriznanie',
          title: this.$t('message.wizPage2'),
          completed: false
        },
        {
          icon: 'fas fa-list-alt',
          name: 'udajeDanovnikovi',
          alias: 'danovnik',
          title: this.$t('message.wizPage3'),
          completed: false
        },
        {
          icon: 'fas fa-money-bill-alt',
          name: 'prijmyVydavky',
          alias: 'tuzemskePar5',
          title: this.$t('message.wizPage4'),
          completed: false
        },
        {
          icon: 'fas fa-download',
          name: 'download',
          title: this.$t('message.wizPage5'),
          completed: false
        }
      ]
    }
  },

  inject: ['restDataSource'],

  mounted() {
    this.$refs.wizard.activateAll()
  },

  watch: {
    currentStep(newS) {
      this.$store.commit('setLastIndex', newS)
      this.$refs.wizard.changeTab(2, newS)
    }
  },

  computed: {
    currentStep() {
      const matched = this.$route.matched[0].name
      const activeStep = this.steps.find(x => x.name === matched)
      return this.steps.indexOf(activeStep)
    }
  },

  methods: {
    danovnikSwitch() {
      if (this.$route.params.userId === undefined) {
        alert(this.$t('message.msgSelectDan'))
        return false
      }
      return true
    },

    next() {
      if (this.$store.state.stopWizard === true) {
        const answer = window.confirm('Ďalej bez uloženia údajov?')
        if (answer === true) {
          this.$store.commit('stopWizard', false)
          return true
        }
        return false
      }
      return true
    },

    tabChange() {
      this.$store.commit('stopWizard', false)

      this.$nextTick(() => {
        if (this.$refs.wizard) {
          const activeTab = this.$refs.wizard.activeTabIndex

          if (activeTab !== undefined) {
            const nextStep = this.steps[activeTab]
            const routeName = nextStep.alias ? nextStep.alias : nextStep.name

            this.$router.push({ name: routeName })
          }
          return null
        }
        return null
      })
    },

    nextClicked() {
      const step = this.currentStep

      if (step === this.steps.length - 1) {
        return null
      }

      const index = step + 1
      const nextStep = this.steps[index]
      const routeName = nextStep.alias ? nextStep.alias : nextStep.name

      if (this.$route.params.userId === undefined && step === 1) {
        this.restDataSource.eventBus.$emit('httpError', this.$t('message.msgSelectDan'))
        return null
      }

      this.$router.push({ name: routeName })

      if (this.$store.state.stopWizard === true) {
        return false
      }

      this.$refs.wizard.nextTab()

      return true
    },

    backClicked() {
      const step = this.currentStep

      if (step === 0) {
        return null
      }
      const index = step - 1
      const nextStep = this.steps[index]

      this.$router.push({ name: nextStep.alias ? nextStep.alias : nextStep.name })

      if (this.$store.state.stopWizard === true) {
        return null
      }

      this.$refs.wizard.prevTab()

      return true
    }
  }
}
</script>

<style>
.wizard-btn {
  display: none!important;
}
.nextBut {
  border-radius: 0;
  background-color: #19baa9;
  text-transform: uppercase;
  border: 0;
}
.nextBut:hover {
  background-color: #29cab9;
}
.backBut {
  border-radius: 0;
  background-color: #3a5878;
  text-transform: uppercase;
  border: 0;
}
.backBut:hover {
  background-color: #4a6888;
}
.vue-form-wizard.md li.active .wizard-icon-circle {
  width: 100px!important;
  height: 70px!important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 70px;
  height: 65px;
  transition: height 350ms, width 350ms;
  font-size: 24px;
  background-color: #fafaff;
}

.vue-form-wizard .wizard-tab-content {
  padding: 10px 20px 10px;
}

</style>
